import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Delete = forwardRef<SVGSVGElement, SvgIconProps>(
  function Delete(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="M7.13 9.12H5.5V7.47h3.25V5.82c0-.45.36-.82.81-.82h4.88c.45 0 .81.37.81.82v1.65h3.25v1.65h-1.63v8.23c0 .91-.72 1.65-1.62 1.65h-6.5c-.9 0-1.63-.74-1.63-1.65V9.12zm1.62 0v7.4c0 .46.36.83.81.83h4.88c.45 0 .81-.37.81-.82V9.12h-6.5zm1.63-1.65h3.24v-.82h-3.24v.82z" />
      </SvgIcon>
    )
  },
)

export default Delete
